module.exports = __webpack_public_path__ + "img/intro_no.ebb36bcb.svg";